import React, { useContext } from 'react'
import { string, func, bool } from 'prop-types'
import { userType } from 'models/propTypes'
import { connect } from 'react-redux'

import { getCurrentUser } from 'models/user/selectors'
import { getCurrentPage, getHideHeader } from 'models/location/selectors'

import { scenesToggle, reloadPage } from 'models/ui/actions'
import { openComposition } from 'models/compositions/actions'
import { logoutUser } from 'models/user/actions'
import SugarcubeContext from 'apps/SugarcubeContext'

import Header from 'components/Header'

const HeaderContainer = ({ user, location, toggleScenes, openDesignPage, logout, refresh, hideHeader }) => {
    const { isKiosk } = useContext(SugarcubeContext)
    if (location === 'signup' || location === 'login' || hideHeader || isKiosk) {
        return null
    }
    return (
        <Header
            user={user}
            location={location}
            toggleSceneSelection={toggleScenes}
            openDesignPage={openDesignPage}
            logout={logout}
            refresh={refresh}
        />
    )
}

HeaderContainer.propTypes = {
    user: userType.isRequired,
    location: string.isRequired,
    toggleScenes: func.isRequired,
    openDesignPage: func.isRequired,
    logout: func.isRequired,
    refresh: func.isRequired,
    hideHeader: bool.isRequired,
}

const mapStateToProps = (state) => ({
    user: getCurrentUser(state),
    location: getCurrentPage(state),
    hideHeader: getHideHeader(state),
})

const mapDispatchToProps = (dispatch) => ({
    toggleScenes: () => dispatch(scenesToggle()),
    openDesignPage: () => dispatch(openComposition(-1)),
    logout: () => dispatch(logoutUser()),
    refresh: () => dispatch(reloadPage()),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer)
